import type { PurchaseMethod, SerializedVariant } from './types';

export function isShoppable(pm: PurchaseMethod) {
    // Shopify is the only native checkout, so an out-of-stock item genuinely
    // can't be added to our cart and is gated by availability. Every other
    // method is an outbound affiliate link that stays shoppable even when our
    // stock feed reports out_of_stock; the shopper just lands on the retailer's
    // own page. Real availability is still surfaced truthfully in the UI.
    if (pm.method_type === 'shopify') {
        return pm.availability !== 'out_of_stock';
    }
    return true;
}

export function getAvailableShopifyMethod(methods: PurchaseMethod[]) {
    return methods.find((m) => m.method_type === 'shopify' && isShoppable(m)) ?? null;
}

export function getOtherMethods(methods: PurchaseMethod[]) {
    return methods.filter((m) => m.method_type !== 'shopify');
}

export function hasShoppablePurchaseMethod(variant: SerializedVariant) {
    return variant.purchase_methods.some(isShoppable);
}
